import React, {
	memo,
	useCallback
} from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';

import styles from '../table.module.css';

const ActivateStaffCell = ( {
	onActivate,
	row
} ) => {
	const handleActivate = useCallback( () => onActivate( row ), [
		onActivate,
		row
	] );

	return (
		<div className={ styles.tableRowActions }>
			<Checkbox
				toggle
				checked={ row.statusID !== 5 }
				size="mini"
				onClick={ handleActivate }
			/>
		</div>
	);
};

ActivateStaffCell.propTypes = {
	onActivate: PropTypes.func,
	row: PropTypes.object.isRequired
};

export default memo( ActivateStaffCell );
